// FM UGC Carousel — centrage + scroll infini + autoplay
// Appelé depuis les sections : fmUGC('track-id', 'prev-id', 'next-id')
// Ou auto-init via data-fm-ugc sur le track

(function() {

  function initCarousel(track, prev, next) {
    if (!track) return;
    var cards = track.children;
    if (!cards.length) return;
    var idx = 0;
    var timer = null;
    var INTERVAL = 3000;

    function gap() {
      var s = getComputedStyle(track);
      return parseInt(s.columnGap || s.gap || '12') || 12;
    }
    function cw() {
      return cards[0] ? cards[0].offsetWidth + gap() : 264;
    }
    function totalW() {
      return cw() * cards.length - gap();
    }
    function wrapW() {
      var p = track.parentElement;
      return p ? p.offsetWidth - 96 : window.innerWidth - 96;
    }
    function isCentered() {
      return totalW() <= wrapW();
    }
    function center() {
      if (isCentered()) {
        track.style.justifyContent = 'center';
        track.style.transform = 'none';
        idx = 0;
      } else {
        track.style.justifyContent = 'flex-start';
      }
    }
    function go(i) {
      if (isCentered()) return;
      var n = cards.length;
      idx = ((i % n) + n) % n;
      track.style.transform = 'translateX(-' + (idx * cw()) + 'px)';
    }

    function startAuto() {
      stopAuto();
      if (isCentered()) return;
      timer = setInterval(function() { go(idx + 1); }, INTERVAL);
    }
    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function() { stopAuto(); go(idx - 1); startAuto(); });
    if (next) next.addEventListener('click', function() { stopAuto(); go(idx + 1); startAuto(); });

    // Touch / drag
    var sx = 0;
    track.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; track.style.transition = 'none'; stopAuto(); }, { passive: true });
    track.addEventListener('touchend', function(e) { track.style.transition = ''; var d = sx - e.changedTouches[0].clientX; if (Math.abs(d) > 40) go(d > 0 ? idx + 1 : idx - 1); startAuto(); });
    track.addEventListener('mousedown', function(e) { sx = e.clientX; track.style.transition = 'none'; stopAuto(); });
    track.addEventListener('mouseup', function(e) { track.style.transition = ''; var d = sx - e.clientX; if (Math.abs(d) > 50) go(d > 0 ? idx + 1 : idx - 1); startAuto(); });

    // Pause au hover
    var wrap = track.parentElement;
    if (wrap) {
      wrap.addEventListener('mouseenter', stopAuto);
      wrap.addEventListener('mouseleave', function() { if (timer === null) startAuto(); });
    }

    // IntersectionObserver — démarre quand visible
    center();
    window.addEventListener('resize', center);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) { startAuto(); }
          else { stopAuto(); }
        });
      }, { threshold: 0.3 });
      io.observe(track);
    } else {
      startAuto();
    }
  }

  // API publique : appelée explicitement depuis les sections
  window.fmUGC = function(trackId, prevId, nextId) {
    var track = document.getElementById(trackId);
    var prev = document.getElementById(prevId);
    var next = document.getElementById(nextId);
    initCarousel(track, prev, next);
  };

  // Auto-init : si le DOM est déjà prêt, init tout de suite
  // sinon attendre DOMContentLoaded
  function autoInit() {
    document.querySelectorAll('[data-fm-ugc]').forEach(function(track) {
      var prevId = track.dataset.fmUgcPrev;
      var nextId = track.dataset.fmUgcNext;
      initCarousel(
        track,
        prevId ? document.getElementById(prevId) : null,
        nextId ? document.getElementById(nextId) : null
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }

})();
